var tagText = 'fx_2d2fb1e5_lz3zmx1';
var tagTextColor = 'var(--fx_2d2fb1e5_lz3zmx0)';

export { tagText, tagTextColor };
//# sourceMappingURL=text.vanilla.mjs.map
